import { useIntl } from "react-intl";
import Switch from "@rio-cloud/rio-uikit/Switch";
import CreateServiceBayDialog from "./dialogs/CreateServiceBay";
import { useState } from "react";
import { ServiceBay } from "../../../../../../models/serviceBay";
import ConfirmDialog from "../../../../../../components/dialogs/ConfirmDialog";

type IServiceBayListProps = {
  serviceBays: ServiceBay[];
  serviceBayIdsSelected: string[];
  selectServiceBay: (serviceBayId: string) => void;
  onCreateServiceBay: (name: string) => Promise<void>;
  onRemoveServiceBay: (serviceBayId: string) => Promise<void>;
};

const ServiceBayList = ({
  serviceBays,
  serviceBayIdsSelected,
  selectServiceBay,
  onCreateServiceBay,
  onRemoveServiceBay,
}: IServiceBayListProps) => {
  const intl = useIntl();
  const [deleteDialog, setDeleteDialog] = useState<{
    show: boolean;
    serviceBayId: string;
  } | null>(null);
  const [createDialog, setCreateDialog] = useState(false);

  return (
    <div className="p-4 max-w-md">
      <div className="flex items-center justify-between text-size-16 text-medium padding-bottom-10">
        <span className="flex items-center w-full">
          <span className="rioglyph rioglyph-calendar" />
          {intl.formatMessage({ id: "intl-msg:dealership.serviceBayList.selectBox" })}
        </span>
        <button
          id="criar-box"
          onClick={() => setCreateDialog(true)}
          className="bg-highlight-dark text-white p-2 rounded w-[24px] h-[24px] flex items-center justify-center"
        >
          <span className="rioglyph rioglyph-plus"></span>
        </button>
      </div>

      <div className="space-y-4">
        {serviceBays.map((serviceBay, index) => {
          const key = `switch${index + 1}`;
          return (
            <div key={key} className="flex items-center justify-between">
              <div className="flex items-center justify-between w-full gap-4 pt-[12px] pb-[8px] pl-[12px]">
                <Switch
                  onChange={() =>
                    serviceBay.id && selectServiceBay(serviceBay.id)
                  }
                  checked={
                    !(
                      serviceBay.id &&
                      !serviceBayIdsSelected.includes(serviceBay.id)
                    )
                  }
                  labelPosition="left"
                >
                  <span className="text-[#2A3740] dark:text-neutral-200 font-semibold text-[12px] uppercase ellipsis">
                    {serviceBay.name}
                  </span>
                </Switch>
                <button
                  onClick={() =>
                    setDeleteDialog({
                      show: true,
                      serviceBayId: serviceBay.id ?? "",
                    })
                  }
                  className="text-[24px] text-color-highlight-dark hover:text-color-danger"
                  title={intl.formatMessage({ id: "intl-msg:dealership.serviceBayList.removeBox" })}
                >
                  <span className="rioglyph rioglyph-trash" />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <CreateServiceBayDialog
        isOpen={createDialog}
        onClose={() => setCreateDialog(false)}
        onSave={async (name) => await onCreateServiceBay(name)}
      />

      <ConfirmDialog
        show={!!deleteDialog}
        title={intl.formatMessage({ id: "intl-msg:dealership.serviceBayList.removeBox" })}
        body={intl.formatMessage({ id: "intl-msg:dealership.serviceBayList.removeConfirm" })}
        onClose={() => setDeleteDialog(null)}
        onConfirm={async () => {
          if (deleteDialog?.serviceBayId) {
            await onRemoveServiceBay(deleteDialog.serviceBayId);
            setDeleteDialog(null);
          }
        }}
      />
    </div>
  );
};

export default ServiceBayList;
